import { ClosedCaptions, CMSCommon, Caption, CmsCaption } from './cms-data';
import { Timecode } from './time-code';
import { Utils } from './utils';

export class MetaData {
    private raw: any;
    private sources: string[] = [];
    private captionData: ClosedCaptions = { hash: '', captions: [] };

    constructor(data: CMSCommon | null) {
        if (data) {
            this.raw = data;
        }
    }

    get id(): string {
        return this.raw?.id;
    }

    get postRoll(): string {
        return this.raw?.postRoll || '';
    }

    get title(): string {
        return this.raw?.windowTitle || '';
    }

    get category(): string {
        return this.raw?.category || '';
    }

    get state(): string {
        return this.raw?.state || '';
    }

    get linkUrl(): string[] {
        return this.raw?.linkUrl || '';
    }

    get overlayText(): string[] {
        return this.raw?.overlayText || '';
    }

    get adminDisplay(): string[] {
        return this.raw?.adminDisplay || '';
    }

    get hoverTime(): any {
        return this.raw?.hoverTime;
    }

    get hoverToggle(): boolean {
        return this.raw?.hoverToggle;
    }

    get chapteredVideo(): any {
        return this.raw?.chapteredVideo;
    }

    get seconds(): number {
        return this.raw?.length ? Utils.timecodeToSeconds(this.raw?.length) : 0;
    }

    get startMode(): string {
        return this.raw?.startMode;
    }

    get duration(): string {
        return this.raw?.length || '';
    }
    get ptDuration(): string {
        return Timecode.getHumanizeDuration(this.raw?.length);
    }

    appendCaptions(captions: Caption[]): void {
        const captionsLength = captions.length;
        for (let i = 0; i < captionsLength; i++) {
            const obj = captions[i];
            obj.begin += this.seconds;
            obj.end += this.seconds;
            this.captionData.captions.push(obj);
        }
    }

    get captions(): ClosedCaptions {
        if (!this.captionData.captions.length && this.raw?.timelineCaptions) {
            const captionString: string = this.raw?.timelineCaptions;
            if (captionString) {
                try {
                    const captions =
                        typeof captionString === 'string'
                            ? JSON.parse(captionString)
                            : captionString;
                    if (captions) {
                        captions.forEach((e: CmsCaption) => {
                            let captionText = e.t;
                            captionText = captionText.replace(/\<br.*\/\>/g, ' '); // not happy about this...
                            captionText = captionText.replace(/<br>/gi, ' ');
                            const obj: Caption = {
                                begin: Math.floor(Utils.timecodeToSeconds(e.b)),
                                end: Math.floor(Utils.timecodeToSeconds(e.e)),
                                text: captionText,
                            };
                            this.captionData.captions.push(obj);
                        });
                    }
                } catch (e) {
                    console.error(
                        'JSON.parse exception occrrerd for caption in asset',
                        this.adminDisplayName,
                        e,
                    );
                }
            }
        }
        return this.captionData;
    }

    get description(): string {
        return this.raw?.description || '';
    }

    get date(): string {
        return this.raw?.launchDate || '';
    }

    get name(): string {
        return this.adminDisplayName + '/' + this.adminDisplayName;
    }

    get adminDisplayName(): string {
        return this.raw?.adminDisplay;
    }

    get cmsPath(): string {
        const folderPath = this.raw?.folderPath;
        return folderPath && folderPath[folderPath.length - 1] !== '/'
            ? folderPath + '/'
            : folderPath;
    }
    get folder(): string {
        const folder = '//gvpcertvideos.att.com';
        return folder + (this.cmsPath?.indexOf('//') === 0 ? '' : '/') + this.cmsPath;
    }

    get thumbnail(): string {
        return Utils.prependProtocol(this.folder + this.name + '_360.jpg');
    }

    get poster(): string {
        if (this.isB2B) {
            return Utils.prependProtocol(this.folder + this.name + '_640x360.jpg');
        } else {
            return Utils.prependProtocol(this.folder + this.name + '_480.jpg');
        }
    }

    get closedCaptionFile(): string {
        return this.folder + this.name + '.vtt';
    }

    addSource(source: string): void {
        this.sources.push(source);
    }
    get seoSource(): string[] {
        return new Array(Utils.prependProtocol(this.folder + this.name + '_360')).concat(
            this.sources,
        );
    }
    get sourceTypes(): string[] {
        return this.raw?.formats;
    }
    get source(): string[] {
        if (this.isB2B) {
            return new Array(Utils.prependProtocol(this.folder + this.name)).concat(
                this.sources,
            );
        } else {
            return new Array(
                Utils.prependProtocol(this.folder + this.name + '_480'),
            ).concat(this.sources);
        }
    }

    get isB2B(): boolean {
        if (this.category.indexOf('B2B') > 0) {
            return true;
        }
        return false;
    }
}
